@if (gallery.filterItems(); as fis) {
    @if (fis.length) {
        <div class="gallery-filter" [@slideDownAnimation]="fis.length">
            <button i18n class="filter-btn" [class.active]="!this.filter() || this.filter().length === 0" [routerLink]="[]" [queryParams]="{}">All</button>
            @for (f of fis; track f._id) {
                <button class="filter-btn" [routerLink]="[]" [queryParams]="{ filter: f.name }" [class.active]="f._id === this.filter()">
                    {{ f.name | titlecase }}
                </button>
            }
        </div>
    }
}

<!-- style="min-height: calc(100vh - 165px)" -->
<div
    class="row"
    infinite-scroll
    [fromRoot]="true"
    [infiniteScrollDistance]="infiniteScrollDistance"
    [infiniteScrollThrottle]="150"
    (scrolled)="onScrollDown()"
    [infiniteScrollContainer]="'body'"
>
    @for (col of galleryColumns(); track i; let i = $index) {
        <div #column class="gallery column" [@slideUpAnimation]="col().length">
            @for (item of col(); track $index) {
                <a
                    id="{{ item.slug }}"
                    class="gallery-item"
                    [routerLink]="['/', this.gallery.category, 'canvas', item.slug]"
                    [queryParams]="{ filter: this.filter() || undefined }"
                >
                    <img
                        placeholder
                        [ngSrc]="item.src"
                        [width]="item.width"
                        [height]="item.height"
                        priority
                        class="white-black colored-on-hover"
                        style="height: auto"
                        alt="{{ item.title || item.slug }}"
                    />
                    @if (item.showTitle === true && item.title) {
                        <h5 class="title">{{ item.title }}</h5>
                    }
                </a>
            }
        </div>
    }
</div>
<div class="text-center my-16" style="line-height: 1.5">
    @if (!gallery.canGetMore() && gallery.all().length) {
        <span i18n="@@gallery.max-content">You've reached the final brushstroke of this collection.</span>
        <br />
        <span i18n="@@gallery.max-content-keep-in-touch">Stay tuned for the unveiling of new artistry.</span>
    } @else if (!gallery.canGetMore() && gallery.all().length === 0) {
        <span i18n="@@gallery.empty-collection">The gallery awaits its first brushstrokes of inspiration.</span>
        <br />
        <span i18n="@@gallery.empty-collection-keep-in-touch">Return soon to witness the birth of a new collection.</span>
    }
</div>
